import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  nojoomDashboardMsisdnData: null,
  nojoomDashboardMessageData: null,
  clickedTrasferPointsCardData: null,
  refetchNojoomPage: false,
}

export const nojoomSlice = createSlice({
  name: "nojoomData",
  initialState,
  reducers: {
    setNojoomDashboardMsisdnData: (state, action) => {
      state.nojoomDashboardMsisdnData = action.payload;
    },
    setNojoomDashboardMessageData: (state, action) => {
      state.nojoomDashboardMessageData = action.payload;
    },
    setClickedTrasferPointsCardData: (state, action) => {
      state.clickedTrasferPointsCardData = action.payload;
    },
    setRefetchNojoomPage: (state, action) => {
      state.refetchNojoomPage = action.payload;
    },
    resetNojoomReduxData: () => initialState,
  },
});

export const {
  setThemeColor,
  setNojoomStatus,
  setNojoomDashboardMsisdnData,
  setNojoomDashboardMessageData,
  setClickedTrasferPointsCardData,
  setRefetchNojoomPage,
  resetNojoomReduxData
} = nojoomSlice.actions;
export default nojoomSlice.reducer;